import { Link } from "lucide-react";
import { Kbd, KbdGroup } from "@/components/ui/kbd";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import {
  copyCurrentPageUrl,
  getCopyPageUrlShortcutKeys,
  getCopyPageUrlShortcutLabel,
} from "@/lib/copy-page-url";

export function CopyPageUrlButton() {
  const shortcutKeys = getCopyPageUrlShortcutKeys();
  const shortcutLabel = getCopyPageUrlShortcutLabel();

  return (
    <Tooltip>
      <TooltipTrigger
        className="flex size-8 shrink-0 items-center justify-center text-muted-foreground transition-colors hover:bg-muted/50 hover:text-foreground"
        aria-label={`Copy page URL (${shortcutLabel})`}
        onClick={() => {
          void copyCurrentPageUrl();
        }}
      >
        <Link className="size-4" />
      </TooltipTrigger>
      <TooltipContent side="bottom" className="flex items-center gap-2">
        <span>Copy page URL</span>
        <KbdGroup>
          <Kbd>{shortcutKeys[0]}</Kbd>
          <Kbd>{shortcutKeys[1]}</Kbd>
          <Kbd>{shortcutKeys[2]}</Kbd>
        </KbdGroup>
      </TooltipContent>
    </Tooltip>
  );
}
